(function () {
  'use strict';

  var observer = null;
  var touchMode = null;

  function isEnabled() {
    var body = document.body;
    return body && body.getAttribute('data-product-title-truncate') === 'true';
  }

  function isTouchLike() {
    if (touchMode !== null) return touchMode;
    // Prefer MQs over UA sniffing.
    touchMode = !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
    return touchMode;
  }

  function toNumber(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function measureOne(titleEl) {
    if (!titleEl) return;

    var inner = titleEl.querySelector('[data-grid-product-title-inner]');
    if (!inner) return;

    // Reset first so measurement is accurate
    titleEl.classList.remove('is-overflowing');
    titleEl.style.removeProperty('--product-title-overflow');
    titleEl.style.removeProperty('--product-title-duration');

    // Ensure layout is settled
    var available = titleEl.clientWidth;
    var needed = inner.scrollWidth;

    // Guard for hidden elements
    if (!available || !needed) return;

    var overflow = Math.max(0, needed - available);
    if (overflow < 2) return;

    // Duration based on a constant speed (px/s)
    var pxPerSecond = 40;
    var duration = Math.max(2.5, overflow / pxPerSecond + 1.2);

    titleEl.classList.add('is-overflowing');
    titleEl.style.setProperty('--product-title-overflow', overflow + 'px');
    titleEl.style.setProperty('--product-title-duration', duration.toFixed(2) + 's');

    // In touch mode, auto-play when it becomes visible.
    if (isTouchLike()) {
      observeForAutoplay(titleEl);
    }
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (!el || el.getAttribute('data-title-autoplayed') === 'true') return;
          if (!el.classList.contains('is-overflowing')) return;

          el.setAttribute('data-title-autoplayed', 'true');
          el.classList.add('is-auto-playing');

          var inner = el.querySelector('[data-grid-product-title-inner]');
          if (inner) {
            var onEnd = function () {
              el.classList.remove('is-auto-playing');
              inner.removeEventListener('animationend', onEnd);
            };
            inner.addEventListener('animationend', onEnd);
          }

          // Stop observing once played.
          observer.unobserve(el);
        });
      },
      { threshold: 0.75 }
    );
  }

  function observeForAutoplay(titleEl) {
    ensureObserver();
    if (!observer) return;
    if (titleEl.getAttribute('data-title-autoplayed') === 'true') return;
    observer.observe(titleEl);
  }

  function init(container) {
    if (!isEnabled()) return;

    var scope = container || document;
    var titles = scope.querySelectorAll('[data-grid-product-title]');
    titles.forEach(function (titleEl) {
      measureOne(titleEl);
    });
  }

  var resizeTimer = null;
  function onResize() {
    if (!isEnabled()) return;

    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      init(document);
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  window.addEventListener('resize', onResize);

  // Theme editor / dynamic section loads
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    init(evt.target);
  });
})();
